import React, { CSSProperties } from 'react';
import styled from 'styled-components';

import { FontStyle } from '@/utils/StyleUtil';

interface IProps {
    text: string;
    color: string;
    borderRadius: number;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    className?: string;
    active?: boolean;
    fontStyle?: CSSProperties;
    nonActiveStyle?: CSSProperties;
}

const BorderRoundButton = ({
    text,
    color,
    borderRadius,
    onClick,
    className,
    active = true,
    nonActiveStyle,
    fontStyle,
}: IProps) => {
    return (
        <Button
            active={active}
            nonActiveStyle={nonActiveStyle}
            data-cy={text}
            className={className}
            borderRadius={borderRadius}
            color={color}
            onClick={onClick}
            fontStyle={fontStyle}
        >
            {text}
        </Button>
    );
};

const Button = styled.button<{
    color: string;
    borderRadius: number;
    active: boolean;
    nonActiveStyle?: CSSProperties;
    fontStyle?: CSSProperties;
}>`
    background-color: ${({ color, active, nonActiveStyle }) => (active ? color : nonActiveStyle?.backgroundColor)};
    border-radius: ${({ borderRadius }) => borderRadius}px;
    padding: 5px 10px;
    ${FontStyle(12, 18, '500', '#ffffff')}
    color: ${({ active, nonActiveStyle }) => (active ? '#ffffff' : nonActiveStyle?.color)};
    ${({ fontStyle }) => ({ ...fontStyle })};
`;

export default BorderRoundButton;
